import * as React from 'react';

interface IWeightDisplayProps {
  weight?: number;
}

class WeightDisplay extends React.Component<IWeightDisplayProps> {

  public render() {
    const { weight } = this.props;

    if (weight) {
      if (weight > 1000) {
        return `${Math.round(weight / 10) / 100} kg`;
      } else {
        return `${weight} g`;
      }
    }

    return null;
  }
}

export default WeightDisplay;


// WEBPACK FOOTER //
// ./src/components/Others/WeightDisplay/WeightDisplay.tsx